'use client'

import styled from "styled-components";
import Modal from "@/components/UI/Containers/Modal/Modal";
import Title from "@/components/UI/Title/Title";
import Description from "@/components/UI/Description/Description";
import Form from "@/components/UI/Form/Form/Form";
import EmailInput from "@/components/UI/Form/Inputs/EmailInput/EmailInput";
import Submit from "@/components/UI/Form/Submit/Submit";


export const ForgotPassword = styled(Modal)`
    max-width: 610px;

    .ant-modal-content {
        padding: 40px 70px;
    }
`

export const ForgotPasswordTitleDescWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 27px;
    width: 100%;
`

export const ForgotPasswordTitle = styled(Title).attrs({
    size: 'sm'
})`
    font-size: 24px;
`
export const ForgotPasswordDescription = styled(Description).attrs({
    size: 'sm'
})``

export const ForgotPasswordForm = styled(Form)`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: clamp(15px, 2vw, 30px);
`

export const ForgotPasswordInput = styled(EmailInput)`
    margin-top: 40px;
`

export const SubmitButton = styled(Submit).attrs({
    color: 'secondaryDark',
    size: 'md',
})`
    font-size: 14px;
    padding: 15px 40px;
    letter-spacing: 1px;
`